import { Button, Form, FormGroup, Input, Label } from "reactstrap";

interface Props {
  companyCountrySurvey: string;
  companyStateSurvey: string;
  companyCapitalSurvey: string;
  japaneseEmployeeSurvey: string;
  handleChange: (event: any) => void;
  handleNext: (event: any) => void;
  handlePrevious: (event: any) => void;
}

// MemberCategoryForm
export const StepTwo: React.FC<Props> = ({ companyCountrySurvey, companyStateSurvey, companyCapitalSurvey, japaneseEmployeeSurvey, handleChange, handleNext, handlePrevious }) => {
  return (
    <>
      <h2 className='pt-5 pb-3 font-weight-bold'><strong>会員資格の確認 / Membership Category Checklist</strong></h2>
      <Form className='pt-5'>
        <Label>1. 入会予定の会社はマレーシアですか？</Label>
        <Label>Is your company located in Malaysia?<span style={{ color: "red" }}> (*)</span></Label>
        <FormGroup check>
          <Input
            id="companyCountrySurvey"
            name="companyCountrySurvey"
            type="select"
            value={companyCountrySurvey}
            onChange={handleChange}
          >
            <option></option>
            <option key="yes" value="yes">はい / Yes</option>
            <option key="no" value="no">いいえ / No</option>
          </Input>
        </FormGroup>
      </Form>

      <Form className='pt-5'>
        <Label>2. 所在地は下記エリアにあたられますか？</Label>
        <Label>Is your company located in the state below?<span style={{ color: "red" }}> (*)</span></Label>
        <FormGroup check>
          <Input
            id="companyStateSurvey"
            name="companyStateSurvey"
            type="select"
            value={companyStateSurvey}
            onChange={handleChange}
          >
            <option></option>
            <option key="penang" value="penang">ペナン / Penang</option>
            <option key="perak" value="perak">ペラ / Perak</option>
            <option key="malacca" value="malacca">マラッカ / Malacca</option>
            <option key="johor" value="johor">ジョホール / Johor</option>
            <option key="others" value="others">上記に該当しない / None of the above</option>
          </Input>
        </FormGroup>
      </Form>

      <Form className='pt-5'>
        <Label>3. 日本資本は入っていますか？</Label>
        <Label>Do you have Japanese capital?<span style={{ color: "red" }}> (*)</span></Label>
        <FormGroup check>
          <Input
            id="companyCapitalSurvey"
            name="companyCapitalSurvey"
            type="select"
            value={companyCapitalSurvey}
            onChange={handleChange}
          >
            <option></option>
            <option key="yes" value="yes">はい / Yes</option>
            <option key="no" value="no">いいえ / No</option>
          </Input>
        </FormGroup>
      </Form>

      <Form className='pt-5'>
        <Label>4. 日本人は在籍していますか？</Label>
        <Label>Do you have Japanese employees?<span style={{ color: "red" }}> (*)</span></Label>
        <FormGroup check>
          <Input
            id="japaneseEmployeeSurvey"
            name="japaneseEmployeeSurvey"
            type="select"
            value={japaneseEmployeeSurvey}
            onChange={handleChange}
          >
            <option></option>
            <option key="yes" value="yes">はい / Yes</option>
            <option key="no" value="no">いいえ / No</option>
          </Input>
        </FormGroup>
      </Form>
      <div className='justify-content-end pt-5 d-flex gap-3'>
        <Button 
          color="secondary" 
          outline
          onClick={handlePrevious}
          >戻る / Previous
        </Button>
				<Button 
					color="info" 
					outline
          disabled={!companyCountrySurvey || !companyCapitalSurvey || !japaneseEmployeeSurvey}
          onClick={handleNext}
					>次へ / Next
				</Button>
			</div>
    </>
  );
};